export const errorMessage = (error: any, default_message: string): string => {
    return typeof error === "string" ? error : typeof error === "undefined" || !error.message ? default_message : error.message;
};

export const SECONDS_PER_DAY = 86400;
